import { getInitials, hashColor } from '@/utils/chatHelpers'
import type { DmParticipant } from '@/types/direct-message'

interface DmAvatarStackProps {
  participants: DmParticipant[]
  isActive?: boolean
  currentUserId?: string
}

export function DmAvatarStack({ participants, isActive = false, currentUserId }: DmAvatarStackProps) {
  const max = 3
  const others = currentUserId
    ? participants.filter(p => p.user_id !== currentUserId)
    : participants
  const pool = others.length > 0 ? others : participants
  const shown = pool.slice(0, max)
  const extra = pool.length - shown.length

  return (
    <div className="relative shrink-0 flex avatar-stack">
      {shown.map((p, i) => (
        <div
          key={p.user_id}
          className="w-9 h-9 text-xs rounded-full flex items-center justify-center text-white font-bold border-2"
          style={{
            backgroundColor: hashColor(p.user_id),
            borderColor: isActive ? '#1e293b' : '#fff',
            zIndex: max - i,
          }}
          title={p.name}
        >
          {getInitials(p.name)}
        </div>
      ))}
      {extra > 0 && (
        <div
          className="w-9 h-9 text-xs rounded-full bg-gray-400 flex items-center justify-center text-white font-bold border-2"
          style={{ borderColor: isActive ? '#1e293b' : '#fff', zIndex: 0 }}
        >
          +{extra}
        </div>
      )}
    </div>
  )
}
